
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitotuljapurcarrental() {



    const cardData =
    {
        keyword: ' Mumbai to Tuljapur Car Rental',
        heading: 'Deva Cabs:  Mumbai to Tuljapur Car Rental',
        headingDescription: 'Deva Cabs offers reliable, comfortable, and hassle-free car rental services from Mumbai to Tuljapur. Whether you are planning a spiritual visit to the famous Tulja Bhavani Temple or traveling with family for a peaceful getaway, our professional drivers and clean, well-maintained vehicles ensure a safe and stress-free journey. Tuljapur, a revered pilgrimage site in Maharashtra, draws thousands of devotees year-round. With flexible rental plans, multiple car options, and affordable pricing, Deva Cabs guarantees a smooth and devotional travel experience from Mumbai to Tuljapur.',

        top: 'Top Places to Visit in Tuljapur with Deva Cabs',

"topPlaces": [
  {
    "title": "Shree Tulja Bhavani Temple",
    "location": "Tuljapur, Dharashiv (Osmanabad), Maharashtra",
    "description": "A revered 12th‑century Shakti Peetha dedicated to Goddess Bhavani, Tulja Bhavani Temple draws millions annually. Built in Hemadpanthi style by Maratha king Māradadeva, it holds deep cultural and religious significance—especially among the Bhosale clan and devotees from across Maharashtra :contentReference[oaicite:2]{index=2}."
  },
  {
    "title": "Chintamani Temple",
    "location": "Tuljapur, Dharashiv, Maharashtra",
    "description": "A unique shrine carved from a single spherical rock, housing ancient idols and palanquins. Located adjacent to the Bhavani Temple complex, this serene temple offers a peaceful spot for meditation and spiritual reflection :contentReference[oaicite:3]{index=3}."
  },
  {
    "title": "Ghat Shila Temple",
    "location": "Tuljapur, Dharashiv, Maharashtra",
    "description": "An ancient temple steeped in mythology and associated with the Ramayana. Nestled among natural rock formations, it’s a hushed retreat favored by devotees and visitors seeking quiet spiritual ambience :contentReference[oaicite:4]{index=4}."
  },
  {
    "title": "Kallola Tirth Tank",
    "location": "Tuljapur, Dharashiv, Maharashtra",
    "description": "A sacred water tank within Tuljapur famed for its ritual significance. Pilgrims take holy dips here, believing in its purifying powers—making it a vital part of the spiritual circuit :contentReference[oaicite:5]{index=5}."
  },
  {
    "title": "Papanashi Tirth",
    "location": "Tuljapur, Dharashiv, Maharashtra",
    "description": "Another revered tirth in town where devotees perform cleansing rituals. Known for its tranquil surroundings and devotional atmosphere, it forms an essential stop on pilgrimage routes :contentReference[oaicite:6]{index=6}."
  },
  {
    "title": "Vishnu Tirth",
    "location": "Tuljapur, Dharashiv, Maharashtra",
    "description": "A holy bathing place where pilgrims immerse themselves in a confluence of sacred waters. Believed to have spiritual healing properties, it's a must‑visit for ritual seekers :contentReference[oaicite:7]{index=7}."
  },
  {
    "title": "Dhakte Tuljapur (Lower Tuljapur)",
    "location": "Tuljapur outskirts, Dharashiv, Maharashtra",
    "description": "A calming area on the outskirts known for its lush greenery and open spaces. This lesser‑visited spot is ideal for couples, families, and anyone seeking natural beauty combined with spiritual solace :contentReference[oaicite:8]{index=8}."
  },
  {
    "title": "Bharati Buwa’s Mutt",
    "location": "Tuljapur, Dharashiv, Maharashtra",
    "description": "A small yet tranquil ashram honoring Saint Bharati Buwa. It draws a calm crowd of seekers interested in meditation, spiritual teachings, and reflective retreats :contentReference[oaicite:9]{index=9}."
  },
  {
    "title": "Naldurg Fort",
    "location": "Naldurg, Tuljapur Taluka, Dharashiv district, Maharashtra",
    "description": "Located ~35 km from Tuljapur, Naldurg Fort is an imposing basalt‑rock fortification from the Western Chalukya era. Featuring sturdy walls and bastions, it offers history buffs a glimpse into medieval Deccan defence architecture :contentReference[oaicite:10]{index=10}."
  },
  {
    "title": "Harni Dam",
    "location": "Tuljapur, Dharashiv, Maharashtra",
    "description": "An earth‑fill irrigation dam built in 1965 on a local river. With its reservoir and surrounding greenery, Harni Dam is a pleasant escape for picnickers, bird‑watchers, and countryside visitors :contentReference[oaicite:11]{index=11}."
  }
],



"services": [
    {
        "name": "Mumbai to Tuljapur Car Rental",
        "description": "Reliable and affordable car rental service from Mumbai to Tuljapur. Choose from a range of well-maintained vehicles perfect for business trips, family outings, or leisure travel."
    },
    {
        "name": "Outstation Car Rental Mumbai to Tuljapur",
        "description": "Enjoy hassle-free outstation car rental services from Mumbai to Tuljapur with flexible booking options, professional chauffeurs, and comfortable rides."
    },
    {
        "name": "Book Tuljapur Car from Mumbai",
        "description": "Easily book your Mumbai to Tuljapur car online with transparent pricing, quick confirmation, and a fleet of sedans, SUVs, and luxury vehicles."
    },
    {
        "name": "Chauffeur Car Rental to Tuljapur",
        "description": "Travel in style and comfort with our chauffeur-driven car rental service from Mumbai to Tuljapur, ensuring a safe and convenient journey."
    },
    {
        "name": "Luxury Car Rental Mumbai to Tuljapur",
        "description": "Experience premium travel with our luxury car rental options from Mumbai to Tuljapur. Ideal for corporate clients and special occasions."
    },
    {
        "name": "SUV Rental to Tuljapur",
        "description": "Spacious and powerful SUV rentals available from Mumbai to Tuljapur, perfect for family trips and group travel with ample luggage space."
    },
    {
        "name": "Mumbai to Tuljapur Cab Hire",
        "description": "Affordable and reliable cab hire services from Mumbai to Tuljapur, suitable for one-way trips or round trips with professional drivers."
    },
    {
        "name": "Online Car Booking Mumbai to Tuljapur",
        "description": "Conveniently book your Mumbai to Tuljapur car online anytime with instant confirmation and a choice of vehicle types to suit your needs."
    },
    {
        "name": "Affordable Tuljapur Car Rental Mumbai",
        "description": "Get cost-effective car rental options from Mumbai to Tuljapur without compromising on quality and safety. Perfect for budget-conscious travelers."
    },
    {
        "name": "Premium Tuljapur Taxi from Mumbai",
        "description": "Opt for our premium taxi service from Mumbai to Tuljapur featuring well-maintained vehicles and experienced chauffeurs for a smooth ride."
    },
    {
        "name": "One Way Car Rental to Tuljapur",
        "description": "Flexible one-way car rental options available from Mumbai to Tuljapur, ideal for business trips and quick visits."
    },
    {
        "name": "Family Car Rental Mumbai to Tuljapur",
        "description": "Spacious family car rental services from Mumbai to Tuljapur with comfortable seating and luggage space for a pleasant journey."
    },
    {
        "name": "Mumbai Airport to Tuljapur Car",
        "description": "Reliable airport transfer services from Mumbai Airport to Tuljapur with timely pickups, clean vehicles, and professional drivers."
    },
    {
        "name": "Mumbai to Tuljapur Tour Car Hire",
        "description": "Plan your Tuljapur tour with our dedicated car hire service from Mumbai, offering customized packages, flexible itineraries, and comfortable travel."
    }
],

"tableData": [
    ["Mumbai to Tuljapur Car Rental", "-Outstation Car Rental Mumbai to Tuljapur"],
    ["Book Tuljapur Car from Mumbai", "-Chauffeur Car Rental to Tuljapur"],
    ["Luxury Car Rental Mumbai to Tuljapur", "-SUV Rental to Tuljapur"],
    ["Mumbai to Tuljapur Cab Hire", "-Online Car Booking Mumbai to Tuljapur"],
    ["Affordable Tuljapur Car Rental Mumbai", "-Premium Tuljapur Taxi from Mumbai"],
    ["One Way Car Rental to Tuljapur", "-Family Car Rental Mumbai to Tuljapur"],
    ["Mumbai Airport to Tuljapur Car", "-Mumbai to Tuljapur Tour Car Hire"]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and On-Time Pickup from Mumbai",
    "WhyChoosedescription": "Deva Cabs guarantees punctual pickups from anywhere in Mumbai for your trip to Tuljapur. Begin your journey on time and stress-free, every time."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our clean, air-conditioned cars provide a comfortable ride for long-distance travel from Mumbai to Tuljapur. Spacious seating and ample luggage space ensure a relaxing trip."
  },
  {
    "WhyChooseheading": "Skilled Drivers Familiar with Tuljapur Routes",
    "WhyChoosedescription": "Our experienced drivers know the best routes to Tuljapur and drive safely to ensure you reach your destination efficiently and comfortably."
  },
  {
    "WhyChooseheading": "Transparent and Fair Pricing",
    "WhyChoosedescription": "Deva Cabs offers clear fare estimates with no hidden charges for your Mumbai to Tuljapur car rental. Enjoy peace of mind with our honest pricing policy."
  },
  {
    "WhyChooseheading": "24/7 Availability for Your Convenience",
    "WhyChoosedescription": "Whether you need an early morning pickup or a late-night return, Deva Cabs is available around the clock for your Mumbai to Tuljapur travel needs."
  },
  {
    "WhyChooseheading": "Safety is Our Priority",
    "WhyChoosedescription": "Our vehicles are regularly sanitized and equipped with safety features. Our drivers follow all traffic rules to ensure your safe journey."
  },
  {
    "WhyChooseheading": "Quick and Easy Booking Process",
    "WhyChoosedescription": "Book your Mumbai to Tuljapur car rental quickly via our app, website, or call center. Receive instant confirmation and real-time driver tracking."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to You",
    "WhyChoosedescription": "Choose from hourly rentals, one-way trips, or round-trip packages for your Mumbai to Tuljapur journey. Deva Cabs adapts to your travel plans effortlessly."
  }
]





















    }




const faqData = [
  {
    question: "Can I rent a car from Mumbai to Tuljapur with Deva Cabs?",
    answer: "Yes, Deva Cabs offers car rental services from Mumbai to Tuljapur. You can easily book your ride via our website, mobile app, or by contacting our customer support."
  },
  {
    question: "What types of cars are available for rent from Mumbai to Tuljapur?",
    answer: "We offer a variety of cars for rent, including hatchbacks, sedans, SUVs, and premium vehicles to ensure a comfortable journey from Mumbai to Tuljapur."
  },
  {
    question: "How long does the journey from Mumbai to Tuljapur take?",
    answer: "The journey from Mumbai to Tuljapur typically takes around 8 to 10 hours depending on the road conditions and traffic."
  },
  {
    question: "Are there any additional charges for renting a car from Mumbai to Tuljapur?",
    answer: "The rental fare includes basic charges for the trip. Any extra charges for tolls, fuel, and driver accommodations (if applicable) will be informed beforehand."
  },
  {
    question: "Can I hire a driver for the Mumbai to Tuljapur car rental?",
    answer: "Yes, all of our car rentals come with experienced drivers who are familiar with the Mumbai to Tuljapur route to ensure a safe and comfortable journey."
  },
  {
    question: "How do I make a payment for the Mumbai to Tuljapur car rental?",
    answer: "You can make payments online via our mobile app or website, or opt for cash or card payments directly with the driver."
  },
  {
    question: "Can I rent the car for a round trip from Mumbai to Tuljapur?",
    answer: "Yes, you can opt for a round trip rental service. We will ensure timely pick-up and drop-off based on your preferences."
  },
  {
    question: "Is the car rental service from Mumbai to Tuljapur available 24/7?",
    answer: "Yes, our car rental services are available 24/7. You can schedule your trip at any time that is convenient for you."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Arvind Shah',
    role: 'Business Executive',
    review: 'I rented a car from Deva Cabs for a trip to Tuljapur. The service was seamless, and the driver was professional and knowledgeable about the route. Highly recommend it!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Priya Agarwal',
    role: 'Tourist',
    review: 'I had a great experience renting a car for my trip to Tuljapur. The ride was smooth, and the driver was courteous and helpful throughout the journey.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Tuljapur Car Rental",
  "image": "https://devacab.com/assets/images/mumbai-to-tuljapur-car-rental.jpg", // Replace with actual image URL
  "description": "Affordable and reliable Mumbai to Tuljapur car rental service by Deva Cabs. Book chauffeur-driven luxury cars, SUVs, and economy vehicles for one-way trips, tours, airport transfers, and family travel.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3800", // Example price, update as needed
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-tuljapur-car-rental" // Replace with actual page URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Tuljapur Car Rental | Outstation Car Rental Mumbai to Tuljapur | Deva Cabs</title>
  <meta
    name="description"
    content="Book affordable Mumbai to Tuljapur car rental with Deva Cabs. Choose from luxury cars, SUVs, and chauffeur-driven vehicles for one-way trips, tours, airport transfers, and family travel."
  />
  <meta
    name="keywords"
    content="Mumbai to Tuljapur Car Rental, Outstation car rental Mumbai to Tuljapur, Book Tuljapur car from Mumbai, Chauffeur car rental to Tuljapur, Luxury car rental Mumbai to Tuljapur, SUV rental to Tuljapur, Mumbai to Tuljapur cab hire, Online car booking Mumbai to Tuljapur, Affordable Tuljapur car rental Mumbai, Premium Tuljapur taxi from Mumbai, One way car rental to Tuljapur, Family car rental Mumbai to Tuljapur, Mumbai airport to Tuljapur car, Mumbai to Tuljapur tour car hire"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/65.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitotuljapurcarrental;